// extracted by mini-css-extract-plugin
module.exports = {"container":"use-case_container__t0uuu","reducedTopPadding":"use-case_reducedTopPadding__tAYGh","reducedTopPaddingMobile":"use-case_reducedTopPaddingMobile__7HYYC"};